module.exports = __webpack_public_path__ + "static/media/wl.0db91511.jpg";